import React            from 'react'; 
import Newspaper        from '../components/Newspaper.jsx';
import Newspaper_4_col  from '../components/Newspaper_4_col.jsx';
import Paper            from '../components/Paper.jsx';
import portrait        from './portrait.module.css';
import landscape        from './use_cases.module.css';
import {Context}        from '../services/context.js'

import pic_use_case_1   from '../pictures/Luxery shoes.webp'; 
import pic_use_case_2   from '../pictures/Palace Hotel San Francisco.webp'; 
import pic_use_case_3   from '../pictures/Airplane Maintenence.webp'; 
import pic_use_case_4   from '../pictures/Petty Cash.webp'; 
import { Helmet }       from 'react-helmet';

import cx              from 'classnames';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});


const text_1 = [{header: <p className={cx_header}>Personal Applications</p>},

  {text: <p className={cx_text}> The Back-Step Blockchain opens up two pivotal avenues for personal use. 
  First, consider Trust.it, our publicly accessible blockchain. It's a common scenario: details and receipts from past purchases, 
  like that specific brand of circuit breakers you bought years ago, slip through the cracks of memory. 
  With Trust.it, every trivial detail can be securely logged on the blockchain, turning forgetfulness into a relic of the past. 
  Whether it's tracking the purchase date of your Samsung phone or storing recipes, the choice of privacy is yours—blocks can be encrypted 
  for your eyes only or left in plain text for public sharing.</p>},

  {text: <p className={cx_text}>Speaking of sharing, my wife, an adept at blending Asian and Western culinary arts, uses Back-Step to share her recipes. The simplicity, speed, 
      and cost-efficiency of our blockchain technology break new ground, offering endless possibilities beyond traditional platforms.</p>},

  {text: <p className={cx_text}> The second category for personal application lies right in your handheld device. It's the foundation for digital currencies and a catalyst for developing 
      myriad exchange and payment solutions. Dive deeper into this under our "Trustful Base for Digital Currencies" section for insights on leveraging the 
      Back-Step Blockchain in your personal device for groundbreaking applications.</p>}
  ];
  

  const text_11 = [{header: <p className={cx_header}>Trusted PriorityMail</p>},

    {text: <p className={cx_text}> <b>E-mail is far from perfect!</b> Everybody can send spam and phishing mail without real control. 
      <b>Trusted PriorityMail</b> is designed to solve this problem. Like traditional paper mail you need a stamp in form of Fee. A spammer would need a 
      Trust.it account with enough Fee to send spam mails. The cost will stop spammers and other unwanted mail. Of course, the mail is stored on the 
      Back-Step Blockchain and encrypted such that only sender an receiver see the readable text. And here comes the catch, the receiver gets most 
      of the Fee paid by the sender credited to its own account. Meaning for legitimate users sending and receiving compensetes the cost. 
      Huge attachments require some extra fee to pay for the lifetime storage cost. We will organize PriorityMail service per country, addresses look like 
      <b> Jeffery.Hinton@Canada_1</b>. Further separation can be provided by multiple dots like <b> lipbutan.001.intel@usa_west. </b> 
      The receiver must be registered at the Back-Step-Blockchain. When sender and receiver are on different Back-Step Blockchains one server keeps the original mail block,
      while the other blockchain creates a reference block. We are working on the technical details.</p>},  
  ];       


const text_2 = [{header : <p className={cx_header} >Small Business Blockchain Applications</p>},
  {text:<p className={cx_text}>For small businesses, the adoption of a Back-Step Blockchain unlocks a myriad of applications. 
   Small businesses can run their own virtual blockchain as a provided service.  
   This technology can revolutionize how businesses manage inventory, accounting, employee records and all business documents. 
   Blockchain allows for secure, immutable recording of petty cash transactions without outdated cash boxes.
   </p>},

   {text: <p className={cx_text}>When was which product bought from wich supplier at what conditions. Blockchain does not forget. Supplier and customer information and detailed product data 
   such as manufacturing lots, version numbers related serial numbers need to be on the blockchain for future reference. Back-Step Blockchain empowers companies with 
  the flexibility to decide which data to share publicly and which to keep private, enhancing both transparency and confidentiality where needed.
  </p>},

  {image:<img src={ pic_use_case_4} width='230' alt="Petty cash" />},];


const text_3 = [{header : <p className={cx_header}>Companies with Valuable Products</p>},
  

  {text:<p className={cx_text}> <b>Combating Product Piracy! </b> Among the myriad applications of the Back-Step Blockchain, its role in deterring product piracy stands out. 
    Traditional anti-piracy measures often fall short due to high costs and complex implementation. Back-Step Blockchain revolutionizes this space with its speed and 
    affordability. At the product's creation, a unique serial number is assigned and recorded on the blockchain. This initial block makes the item traceable through its 
    journey from manufacturing to final sale, with each transit point adding a new block detailing the product's movement.
  </p>},

  {text: <p className={cx_text}><b>How itb works. </b> Upon purchase, the product's sale is also registered, linking it to the buyer's warranty and including a certificate of origin 
    with a unique verification code. If the number fails the cryptographic verification then the product is not origin. 
    The security is based on the secret values inside a chip at the original manufacturers server system linked to the blockchain.   
    This enables consumers to easily verify their product's authenticity and the journey from the factory to their hands. Should a counterfeit 
    attempt to register with the same serial number, the system immediately flags it, capturing relevant data to aid tracking and legal action.
  </p>},

  {text:<p className={cx_text}>This process not only deters piracy but also empowers smaller companies with valuable products to leverage blockchain technology affordably. 
    The Back-Step Blockchain's efficiency shines at the point of sale, where transaction speed is critical. Unlike traditional blockchains, where processing 
    can lag, Back-Step's swift block registration ensures a seamless customer experience.
  </p>},

  {image: <img src={ pic_use_case_1} width='230' alt="Luxery_goods" />}
];

  const text_4_1 = [{header: <p className={cx_header}>Government, Organizations, and Beyond</p>},
  {text: <p className={cx_text}> Discover the myriad applications of the Back-Step Blockchain that save time and instill trust. Join me on a journey to San Francisco in 2028, where I explore 
    its vast possibilities.
  </p>},

  {text: <p className={cx_text} >At the airport, an electronic immigration officer swiftly verified my identity through my new passport, integrated with the Back-Step-Blockchain. This system, 
    linked with Singapore's blockchain, double-checked my biometrics against both the passport's data and the airport's physical sensors. The Back-Step Blockchain 
    ensures the authenticity of my identity and travel history, speeding up my entry without the need for an interview.
  </p>},

  {text:<p className={cx_text}> Upon collecting my luggage, I proceeded to the car rental, where my driver's license was verified online via the Singapore police Back-Step Blockchain. 
    "No faked licenses anymore, thanks to Back-Step Blockchain," remarked the staff. This verification process, facilitated by my personal ID, underscores 
    the technology's role in simplifying everyday transactions—even as self-driving cars render traditional driving skills obsolete.
  </p>},

  {image: <img src={ pic_use_case_2} width='230' alt="Hotel front desk" />},
  
  {text: <p className={cx_text}> At The Palace Hotel, the front desk seamlessly confirmed my reservation through their blockchain. A quick digital ID check, bridging my passport and 
    the hotel's systems—both powered by Back-Step—ensured a swift check-in. The hotel even offered to add its data to my passport blockchain, a 
    testament to Back-Step's flexibility in managing personal travel records and preferences.
  </p>},
  
  {text: <p className={cx_text}> My hotel bill was accessible on their blockchain, allowing me to transfer it to my private blockchain for expense tracking. This integration highlights 
    Back-Step's utility in managing financial records, further exemplified by my use of the Back-Step Wallet for seamless currency management.
  </p>},

  {text:<p className={cx_text}> Registering a subsidiary in the US was remarkably streamlined. By uploading directorial resolutions to my company's blockchain and interacting with 
    various legal entities through their respective blockchains, I experienced a frictionless and efficient process, unencumbered by traditional bureaucratic hurdles.
  </p>},

  {text: <p className={cx_text}> Verifying job candidates' education through university blockchains and discerning authentic news via media blockchains underscored Back-Step's role in ensuring 
    credibility. This technology offers a robust method for authenticating information in an era of misinformation.
  </p>},

  {image: <img src={ pic_use_case_3} width='230' alt="Airplane maintenance" />},
  
  {text:<p className={cx_text}> As I concluded my journey with a flight back to Singapore, I was reassured knowing the aviation industry's reliance on Back-Step Blockchain for maintaining 
    licensing, training, and maintenance records. This implementation not only enhances safety protocols but also ensures transparency and trustworthiness in critical data.
  </p>},

  {text:<p className={cx_text}> Reflecting on my futuristic voyage, it's clear the Back-Step Blockchain's applications are only limited by our imagination. Its potential to revolutionize 
    industries, ensure data integrity, and streamline processes is just beginning to be uncovered.
  </p>},
];



export class UseCases extends React.Component  
{

    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
        super(props);
        this.state = {content_disabled: false}
    }


    //------------------------------------------------
    //  Component Mount
    //------------------------------------------------
    componentDidMount()
    {
        //this.forceUpdate();
        window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    }


    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }

    //--------------------------------------------------------------------------
    // Prepare for rendering  -- Portrait --
    //--------------------------------------------------------------------------
    render()
    { 
      if (Context.portrait)
        {
          this.component = 

          <div className={portrait.backdrop}>

              <Helmet>
              <title> Back-Step Blockchain Use Cases </title>
              <meta name="description" content="Show a few use cases. Many are not possible with traditional blockchains. Imagine, you have your wn blockchain in your phone." />
              <meta charset="utf-8" />
              </Helmet>

              <div className={portrait.title}>
                  A few Back-Step Use Cases
              </div>

              <div > 
                  < Paper  textLines = {text_1}/> 
              </div>

              <div >
                  < Paper  textLines = {text_11}/>
              </div>

              <div >
                  < Paper  textLines = {text_2}/>
              </div>
              
              <div >
                  <Paper  textLines = {text_3}/>
              </div>

              <div >
                  <Paper  textLines = {text_4_1}/>
              </div>

          </div>

        }
        else
        {
        //--------------------------------------------------------------------------
        // Prepare for rendering  -- Landscape --
        //--------------------------------------------------------------------------
          this.component = 
          <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

                <Helmet>
                <title>Use cases for Back-Step Blockchain</title>
                <meta name="description" content="Show a few use cases. Many are not possible with traditional blockchains. Imagine, you have your wn blockchain in your phone." />
                <meta charset="utf-8" />
                </Helmet>

              { ! this.state.content_disabled &&
              <>  
                  <div className={landscape.title_location}>    
                    <div className={landscape.title_text}>
                      <p>A few of thousands Back-Step Use Cases</p>
                    </div>
                  </div>

                <div className={landscape.container}>
             
                    <div > 
                  < Newspaper textLines = {text_1}/> 
                  </div>

                  <div > 
                  < Newspaper textLines = {text_11}/> 
                  </div>

                  <div >
                      <Newspaper  textLines = {text_2}/>
                  </div>
                  
                  <div >
                      <Newspaper  textLines = {text_3}/>
                  </div>

                  <div className = {landscape.grid_item_wide}>
                      <Newspaper_4_col  textLines = {text_4_1}/>
                  </div>

                </div>
              </>
            }
          </div>
        }
    
        return this.component;
    }

}